import { useContext } from 'react';

import { SideNavModalContext, type SideNavModalContextValue } from './side-nav-modal-context';

const SIDE_NAV_MODAL_STUB: SideNavModalContextValue = {
	open: () => {},
	close: () => {},
	isOpen: false,
	disabled: true,
};

export const useSideNavModal = (): SideNavModalContextValue => {
	const context = useContext(SideNavModalContext);

	/**
	 * Return the real modal API only when `SideNavModalProvider` is mounted.
	 * Otherwise return a no-op stub for tests or trees that have not wrapped
	 * with the provider yet.
	 */
	if (context !== null) {
		return context;
	}

	return SIDE_NAV_MODAL_STUB;
};
